export default "__VITE_ASSET__HeQxFvbD__"